import React from "react";

export default function polygonIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="21.297"
      height="18.66"
      viewBox="0 0 21.297 15.66"
      style={{...props.style}}
    >
      <g
        id="Group_4115"
        data-name="Group 4115"
        transform="translate(-1660.699 -133.898)"
      >
        <path
          id="Path_9724"
          data-name="Path 9724"
          d="M-2993.821-1575.375h-5.766l-2.882,4.993,2.882,4.993h5.766l2.882-4.993Z"
          transform="translate(4663.167 1709.272)"
          fill={props.style.color}
        />
        <path
          id="Path_9725"
          data-name="Path 9725"
          d="M-2994.22-1575.047h-5.766l-2.882,4.993,2.882,4.993h5.766l2.882-4.993Z"
          transform="translate(4673.334 1714.619)"
          fill={props.style.color}
        />
      </g>
    </svg>
  );
}
